import React, { useEffect, useState } from "react";
import styled from "styled-components";

const Loadingpage = ({ isLoading }) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  // Use isLoading if provided, otherwise use internal timer 'show'
  const visible = isLoading !== undefined ? isLoading : show;

  if (!visible) return null;

  return (
      <div className="Loader_loaderContainer__cu8Gt">
        <div className="Loader_loader___QBQ5">
          <div className="Loader_loaderImage__1yXsK"></div>
          <div className="Loader_loaderBorder__jbLXv"></div>
        </div>
      </div>
  );
};



export default Loadingpage;
